import React from 'react';
import { t } from 'i18next';
import { Button, ButtonStyle } from '@sovryn/ui';
import { translations } from '../../../locales/i18n';
export const MobileCloseButton = ({ onClick, dataAttribute, }) => (React.createElement("div", { className: "mt-9 block text-center md:hidden" },
    React.createElement(Button, { text: t(translations.common.buttons.close), style: ButtonStyle.ghost, onClick: onClick, dataAttribute: dataAttribute })));
